import { render, staticRenderFns } from "./recruitType.vue?vue&type=template&id=a97090e2&scoped=true"
import script from "./recruitType.vue?vue&type=script&lang=js"
export * from "./recruitType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97090e2",
  null
  
)

export default component.exports